<template>
  <div
    class="company__logo"
    @mouseover="changeHoverIcon(true)"
    @mouseleave="changeHoverIcon(false)"
  >
    <div class="company__logo--left">
      <Picture
        class="logo"
        v-if="!isOpen && !hovered && logo"
        :url="logo.icon ? logo.icon : ''"
        alt="company_logo"
      />
      <Picture
        class="logo"
        v-else-if="isOpen && logo && logo.icon"
        :url="logo.icon ? logo.icon : ''"
        alt="company_logo"
      />
      <div
        v-else-if="!isOpen && hovered"
        class="logo"
        @click="changeOpen"
        :style="isOpen ? '' : 'cursor:pointer;'"
      >
        <Icon iconName="MenuRight" iconColor="#788694" />
      </div>

      <svg
        class="company-name"
        width="97"
        height="24"
        viewBox="0 0 97 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M82.5908 3.01632H85.2672V10.7905H94.3158V3.01632H96.9922V20.8587H94.3158V13.212H85.2672V20.8587H82.5908V3.01632Z"
          fill="#21272C"
        />
        <path
          d="M64.0267 9.08273C63.6528 9.96636 63.4659 10.918 63.4659 11.9375C63.4659 12.9571 63.6528 13.9087 64.0267 14.7923C64.4005 15.6759 64.9018 16.4491 65.5305 17.1118C66.1593 17.7575 66.89 18.2673 67.7226 18.6412C68.5552 19.015 69.4304 19.2019 70.348 19.2019C71.2656 19.2019 72.1407 19.015 72.9734 18.6412C73.806 18.2673 74.5367 17.7575 75.1654 17.1118C75.7942 16.4491 76.2954 15.6759 76.6693 14.7923C77.0431 13.9087 77.23 12.9571 77.23 11.9375C77.23 10.918 77.0431 9.96636 76.6693 9.08273C76.2954 8.19911 75.7942 7.43444 75.1654 6.78871C74.5367 6.126 73.806 5.60772 72.9734 5.23388C72.1407 4.86003 71.2656 4.67311 70.348 4.67311C69.4304 4.67311 68.5552 4.86003 67.7226 5.23388C66.89 5.60772 66.1593 6.126 65.5305 6.78871C64.9018 7.43444 64.4005 8.19911 64.0267 9.08273ZM79.1417 8.16513C79.6515 9.33763 79.9064 10.5951 79.9064 11.9375C79.9064 13.2799 79.6515 14.5374 79.1417 15.7099C78.632 16.8824 77.9437 17.9105 77.0771 18.7941C76.2105 19.6607 75.1994 20.3489 74.0439 20.8587C72.8884 21.3685 71.6564 21.6234 70.348 21.6234C69.0395 21.6234 67.8076 21.3685 66.6521 20.8587C65.4965 20.3489 64.4855 19.6607 63.6188 18.7941C62.7522 17.9105 62.064 16.8824 61.5542 15.7099C61.0444 14.5374 60.7896 13.2799 60.7896 11.9375C60.7896 10.5951 61.0444 9.33763 61.5542 8.16513C62.064 6.99263 62.7522 5.97306 63.6188 5.10643C64.4855 4.22281 65.4965 3.5261 66.6521 3.01632C67.8076 2.50654 69.0395 2.25165 70.348 2.25165C71.6564 2.25165 72.8884 2.50654 74.0439 3.01632C75.1994 3.5261 76.2105 4.22281 77.0771 5.10643C77.9437 5.97306 78.632 6.99263 79.1417 8.16513Z"
          fill="#21272C"
        />
        <path
          d="M55.183 3.01632H58.1143V20.8587H55.4379V7.47692H55.183L46.5167 20.8587H43.5854V3.01632H46.2618V16.3981H46.5167L55.183 3.01632Z"
          fill="#21272C"
        />
        <path
          d="M26.062 3.01632H28.7384V10.7905H37.787V3.01632H40.4634V20.8587H37.787V13.212H28.7384V20.8587H26.062V3.01632Z"
          fill="#21272C"
        />
        <path
          d="M2.67636 20.8587H0V3.01632H2.67636V10.7905H5.73505C5.83701 9.58402 6.12589 8.4625 6.60169 7.42594C7.07748 6.37239 7.69772 5.46328 8.46239 4.69861C9.22707 3.93393 10.1022 3.33919 11.0878 2.91437C12.0903 2.47255 13.1524 2.25165 14.2739 2.25165C15.4124 2.25165 16.5085 2.49804 17.562 2.99083C18.6156 3.46663 19.5332 4.13784 20.3148 5.00447C21.1135 5.85411 21.7507 6.87368 22.2265 8.06317C22.7023 9.25267 22.9402 10.5441 22.9402 11.9375C22.9402 13.3479 22.7023 14.6479 22.2265 15.8374C21.7507 17.0099 21.1135 18.0294 20.3148 18.8961C19.5332 19.7457 18.6156 20.4084 17.562 20.8842C16.5085 21.377 15.4124 21.6234 14.2739 21.6234C13.1524 21.6234 12.0903 21.4025 11.0878 20.9607C10.1022 20.5359 9.22707 19.9496 8.46239 19.2019C7.69772 18.4373 7.07748 17.5451 6.60169 16.5256C6.12589 15.489 5.83701 14.3845 5.73505 13.212H2.67636V20.8587ZM19.7541 14.9197C20.0939 14.0191 20.2639 13.0251 20.2639 11.9375C20.2639 10.85 20.0939 9.8644 19.7541 8.98078C19.4142 8.08016 18.9639 7.31549 18.4032 6.68676C17.8594 6.04103 17.2222 5.54824 16.4915 5.20839C15.7778 4.85154 15.0386 4.67312 14.2739 4.67312C13.5092 4.67312 12.7616 4.85154 12.0309 5.20839C11.3172 5.54824 10.6799 6.04103 10.1192 6.68676C9.57542 7.31549 9.13361 8.08016 8.79375 8.98078C8.4539 9.8644 8.28397 10.85 8.28397 11.9375C8.28397 13.0251 8.4539 14.0191 8.79375 14.9197C9.13361 15.8034 9.57542 16.568 10.1192 17.2138C10.6799 17.8425 11.3172 18.3353 12.0309 18.6921C12.7616 19.032 13.5092 19.2019 14.2739 19.2019C15.0386 19.2019 15.7778 19.032 16.4915 18.6921C17.2222 18.3353 17.8594 17.8425 18.4032 17.2138C18.9639 16.568 19.4142 15.8034 19.7541 14.9197Z"
          fill="#21272C"
        />
      </svg>
    </div>
    <div class="closeIcon" @click="changeOpen">
      <Icon iconName="MenuLeft" iconColor="#788694" />
    </div>
  </div>
</template>
<script>
import Icon from 'Elements/Icon/Icon';
import Picture from 'Elements/Picture/Picture';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    logo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hovered: false
    };
  },
  methods: {
    changeHoverIcon(bool) {
      this.hovered = bool;
    },
    changeOpen() {
      this.$emit('change-open');
      this.hovered = false;
    }
  },
  computed: {},
  components: { Icon, Picture }
};
</script>

<style lang="scss" scoped>
.company__logo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  padding-left: 24px;

  .closeIcon {
    cursor: pointer;
  }

  &--left {
    display: flex;

    .logo {
      width: 24px;
      height: 24px;
      margin-right: 24px;
    }
  }
}
.company-name {
  width: 97px;
  height: 24px;
}
</style>
